const getDsRescueSummary = (t) => ({
    columns: [
        { column: '_day', title: t('report.columns.day'), width: '14%', thClassName: 'text-center', tdClassName: 'text-center' },
        { column: '_9-pending', title: t('report.rescueStatus.pending'), width: '14%', thClassName: 'text-center', tdClassName: 'text-center pointer' },
        { column: '_1-new', title: t('report.rescueStatus.new'), width: '14%', thClassName: 'text-center', tdClassName: 'text-center pointer' },
        { column: '_2-intransit', title: t('report.rescueStatus.intransit'), width: '14%', thClassName: 'text-center', tdClassName: 'text-center pointer' },
        { column: '_3-delivering', title: t('report.rescueStatus.delivering'), width: '14%', thClassName: 'text-center', tdClassName: 'text-center pointer' },
        { column: '_4-returning', title: t('report.rescueStatus.returning'), width: '14%', thClassName: 'text-center', tdClassName: 'text-center pointer' },
        { column: '_0-unknown', title: t('report.rescueStatus.unknown'), width: '14%', thClassName: 'text-center', tdClassName: 'text-center pointer' },
    ],
})

const getDsRescueDetail = (t) => ({
    columns: [
        { column: '_no', title: t('report.columns.no'), width: '5%', thClassName: 'text-center', tdClassName: 'text-center' },
        { column: '_doId', title: t('report.columns.doId'), width: '9%', thClassName: 'text-center', tdClassName: 'text-center' },
        { column: '_trackingCode', title: t('report.columns.trackingCode'), width: '9%', thClassName: 'text-center', tdClassName: 'text-center' },
        { column: '_ffm', title: t('report.columns.ffm'), width: '9%', thClassName: 'text-center', tdClassName: 'text-center' },
        { column: '_lm', title: t('report.columns.lm'), width: '9%', thClassName: 'text-center', tdClassName: 'text-center' },
        { column: '_packageName', title: t('report.columns.packageName'), width: '9%', thClassName: 'text-center', tdClassName: 'text-center' },
        { column: '_amount', title: t('report.columns.amount'), width: '9%', thClassName: 'text-center', tdClassName: 'text-center' },
        { column: '_customerName', title: t('report.columns.customer'), width: '9%', thClassName: 'text-center', tdClassName: 'text-center' },
        { column: '_customerPhone', title: t('report.columns.phone'), width: '9%', thClassName: 'text-center', tdClassName: 'text-center' },
        { column: '_province', title: t('report.columns.province'), width: '9%', thClassName: 'text-center', tdClassName: 'text-center' },
        { column: '_createdate', title: t('report.columns.create'), width: '9%', thClassName: 'text-center', tdClassName: 'text-center' },
    ],
})

const getDsRescuePostback = (t) => ({
    columns: [
        { column: '_date', title: t('report.columns.date'), width: '20%', thClassName: 'text-center', tdClassName: 'text-center' },
        { column: '_status', title: t('report.columns.status'), width: '20%', thClassName: 'text-center', tdClassName: 'text-center' },
        { column: '_reason', title: t('report.columns.reason'), width: '60%', thClassName: 'text-center', tdClassName: 'text-center' },
    ],
})

export {
    getDsRescueSummary,
    getDsRescueDetail,
    getDsRescuePostback,
}
